import { VIEW_H, VIEW_W } from '../domain/content.js';

export interface ScreenLayout {
  x: number;
  y: number;
  w: number;
  h: number;
  scale: number;
  compact: boolean;
}

export interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface TouchControlsLayout {
  left: Rect;
  right: Rect;
  jump: Rect;
  zoomOut: Rect;
  zoomIn: Rect;
}

export function computeScreenLayout(width: number, height: number): ScreenLayout {
  const safeW = Math.max(1, width);
  const safeH = Math.max(1, height);
  const scale = Math.min(safeW / VIEW_W, safeH / VIEW_H);
  const w = VIEW_W * scale;
  const h = VIEW_H * scale;
  return {
    x: Math.floor((safeW - w) / 2),
    y: Math.floor((safeH - h) / 2),
    w,
    h,
    scale,
    compact: w < 700,
  };
}

export function computeTouchControls(layout: ScreenLayout): TouchControlsLayout {
  const size = layout.compact ? 54 : 62;
  const gap = layout.compact ? 10 : 14;
  const y = layout.y + layout.h - size - (layout.compact ? 14 : 18);
  const leftX = layout.x + 18;
  return {
    left: { x: leftX, y, w: size, h: size },
    right: { x: leftX + size + gap, y, w: size, h: size },
    jump: { x: layout.x + layout.w - size - 18, y, w: size, h: size },
    zoomOut: { x: layout.x + layout.w - 18 - size * 2 - gap, y: layout.y + 18, w: size, h: size * 0.72 },
    zoomIn: { x: layout.x + layout.w - 18 - size, y: layout.y + 18, w: size, h: size * 0.72 },
  };
}

export function contains(rect: Rect, x: number, y: number): boolean {
  return x >= rect.x && x <= rect.x + rect.w && y >= rect.y && y <= rect.y + rect.h;
}
